export default "__VITE_ASSET__mOXP$DwS__"